export const UPDATE_DATE = 'UPDATE_DATE';
export const UPDATE_TIMESTAMP = 'UPDATE_TIMESTAMP';
export const UPDATE_LC = 'UPDATE_LC';
export const UPDATE_INIT_DATA = 'UPDATE_INIT_DATA';
export const UPDATE_ORDER_DETAIL = 'UPDATE_ORDER_DETAIL';



// WEBPACK FOOTER //
// ./src/pages/homepage/store/mutation-types.js